import { NavigationSubItem } from "../navigation-item"

export class ClFarmsLiquiditySubItem extends NavigationSubItem {
  readonly id = "cl-farms"
  readonly label = "CL Farms"
  readonly href = "/liquidity/cl-farms"
  readonly iconName = "manage-icon"
  readonly isExternal = false
  readonly tabs = []
}
